<template>
  <div>
    <div class="box_right_tit">Blockchan Data</div>
    <div class="chars_boxlist">
      <div class="charts" @click="diand">
        <div class="charts_tit">
          <div>User Transactions</div>
          <div class="details">
            <span>Details</span> <img src="@/assets/pc/Index/more.png" />
          </div>
        </div>
        <div id="charts" ref="chart" style="width: 406px; height: 290px"></div>
      </div>
      <div class="charts">
        <div class="charts_tit">
          <div>Peak TPS</div>
          <div class="details">
            <span>Details</span> <img src="@/assets/pc/Index/more.png" />
          </div>
        </div>
        <div id="charts" ref="chart1" style="width: 406px; height: 290px"></div>
      </div>
      <div class="charts">
        <div class="charts_tit">
          <div>Transaction signature total</div>
          <div class="details">
            <span>Details</span> <img src="@/assets/pc/Index/more.png" />
          </div>
        </div>
        <div id="charts" ref="chart2" style="width: 406px; height: 290px"></div>
      </div>
      <div class="charts">
        <div class="charts_tit">
          <div>Average Gas Price</div>
          <div class="details">
            <span>Details</span> <img src="@/assets/pc/Index/more.png" />
          </div>
        </div>
        <div id="charts" ref="chart3" style="width: 406px; height: 290px"></div>
      </div>
      <div class="charts">
        <div class="charts_tit">
          <div>Daily Gas Used</div>
          <div class="details">
            <span>Details</span> <img src="@/assets/pc/Index/more.png" />
          </div>
        </div>
        <div id="charts" ref="chart4" style="width: 406px; height: 290px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Homseach from "@/components/pc/serch.vue";

const echarts = require("echarts");
export default {
  data() {
    return {};
  },
  computed: {},
  watch: {
    // deep: true,
    $route: {
      handler: function (to) {
        console.log(to.query);
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    Homseach,
  },
  mounted() {
    this.initCharts();
    this.initCharts1();
    this.initCharts2();
    this.initCharts3();
    this.initCharts4();
  },
  methods: {
    diand() {
      this.$router.push("/pc/TFSCdetail");
    },
    initCharts() {
      this.lineChart = echarts.init(this.$refs.chart);
      let option = {
        tooltip: {
          trigger: "axis",
        },
        // legend: {
        //   data: ["Email", "Union Ads", "Video Ads", "Direct", "Search Engine"],
        // },
        grid: {
          top: "9%",
          left: "3%",
          right: "4%",
          bottom: "8%",
          containLabel: true,
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //   },
        // },
        xAxis: {
          type: "category",
          show: true,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLine: {
            show: false, //隐藏x轴线
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false, //隐藏x轴刻度
          },
        },
        yAxis: {
          type: "value",
          show: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            showSymbol: false,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#00E79A",
                },
                {
                  offset: 0,
                  color: "#00E79A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [820, 932, 901, 934, 1290, 1330, 1320],
          },
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#D3F85A",
                },
                {
                  offset: 0,
                  color: "#D3F85A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#D3F85A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [82, 92, 91, 34, 190, 130, 120],
          },
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            showSymbol: false,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#AC43FC",
                },
                {
                  offset: 0,
                  color: "#AC43FC",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#AC43FC",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [8232, 932, 9231, 3234, 19230, 12330, 12320],
          },
        ],
      };
      this.lineChart.setOption(option);
    },
    initCharts1() {
      this.lineChart = echarts.init(this.$refs.chart1);
      let option = {
        tooltip: {
          trigger: "axis",
        },
        // legend: {
        //   data: ["Email", "Union Ads", "Video Ads", "Direct", "Search Engine"],
        // },
        grid: {
          top: "9%",
          left: "3%",
          right: "4%",
          bottom: "8%",
          containLabel: true,
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //   },
        // },
        xAxis: {
          type: "category",
          show: true,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLine: {
            show: false, //隐藏x轴线
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false, //隐藏x轴刻度
          },
        },
        yAxis: {
          type: "value",
          show: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            showSymbol: false,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#00E79A",
                },
                {
                  offset: 0,
                  color: "#00E79A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [820, 932, 901, 934, 1290, 1330, 1320],
          },
        ],
      };
      this.lineChart.setOption(option);
    },
    initCharts2() {
      this.lineChart = echarts.init(this.$refs.chart2);
      let option = {
        tooltip: {
          trigger: "axis",
        },
        // legend: {
        //   data: ["Email", "Union Ads", "Video Ads", "Direct", "Search Engine"],
        // },
        grid: {
          top: "9%",
          left: "3%",
          right: "4%",
          bottom: "8%",
          containLabel: true,
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //   },
        // },
        xAxis: {
          type: "category",
          show: true,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLine: {
            show: false, //隐藏x轴线
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false, //隐藏x轴刻度
          },
        },
        yAxis: {
          type: "value",
          show: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            showSymbol: false,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#00E79A",
                },
                {
                  offset: 0,
                  color: "#00E79A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#AC43FC",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [8232, 932, 9231, 3234, 19230, 12330, 12320],
          },
        ],
      };
      this.lineChart.setOption(option);
    },
    initCharts3() {
      this.lineChart = echarts.init(this.$refs.chart3);
      let option = {
        tooltip: {
          trigger: "axis",
        },
        // legend: {
        //   data: ["Email", "Union Ads", "Video Ads", "Direct", "Search Engine"],
        // },
        grid: {
          top: "9%",
          left: "3%",
          right: "4%",
          bottom: "8%",
          containLabel: true,
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //   },
        // },
        xAxis: {
          type: "category",
          show: true,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLine: {
            show: false, //隐藏x轴线
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false, //隐藏x轴刻度
          },
        },
        yAxis: {
          type: "value",
          show: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            showSymbol: false,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#00E79A",
                },
                {
                  offset: 0,
                  color: "#00E79A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [8232, 932, 9231, 3234, 19230, 12330, 12320],
          },
        ],
      };
      this.lineChart.setOption(option);
    },
    initCharts4() {
      this.lineChart = echarts.init(this.$refs.chart4);
      let option = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "9%",
          left: "3%",
          right: "4%",
          bottom: "8%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          show: true,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLine: {
            show: false, //隐藏x轴线
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false, //隐藏x轴刻度
          },
        },
        yAxis: {
          type: "value",
          show: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            showSymbol: false,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#00E79A",
                },
                {
                  offset: 0,
                  color: "#00E79A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [8232, 932, 9231, 3234, 19230, 12330, 12320],
          },
        ],
      };
      this.lineChart.setOption(option);
    },
  },
};
</script>

<style lang="less">
.box_right_tit {
  padding-top: 20px;
  margin-left: 20px;
  font-size: 18px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
}
.chars_boxlist {
  display: flex;
  flex-wrap: wrap;
  .charts_tit {
    padding-top: 20px;
    margin-left: 20px;
    font-size: 14px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    display: flex;
    justify-content: space-between;
    .details {
      width: 60px;
      height: 25px;
      line-height: 25px;
      background: #000000;
      border-radius: 6px 6px 6px 6px;

      opacity: 1;
      text-align: center;
      margin-right: 26px;
      span {
        margin-left: 3px;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
      }
      // padding-left: 4px;
      img {
        width: 16px;
        height: 18px;
        margin-top: 6px;
      }
    }
  }
  .charts {
    width: 406px;
    height: 326px;
    background: #0b0c0f;
    border-radius: 16px 16px 16px 16px;
    opacity: 1;
    margin-top: 20px;
    margin-left: 20px;
  }
}
</style>
